var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { mergeStyles } from "@fluentui/react";
import { ListItem } from "./ListItem";
var classNames = {
    orderedList: mergeStyles({
        counterReset: "list",
        li: {
            listStyle: "none",
        },
        "li:before": {
            content: '"("counter(list, lower-alpha) ") "',
            counterIncrement: "list"
        },
    }),
};
export var List = function (props) {
    var usedIds = [];
    var listItems = props.items.map(function (item, index) {
        var _a;
        var itemId;
        var type = typeof item;
        if (type === "object" && ((_a = item.props) === null || _a === void 0 ? void 0 : _a.id))
            itemId = item.props.id;
        else if (type === "string")
            itemId = item;
        else if (type === "number" || type === "boolean")
            itemId = item.toString();
        else
            itemId = "list_item_object" + index;
        if (usedIds.includes(itemId))
            itemId = itemId.concat("-" + index);
        usedIds.push(itemId);
        return _jsx(ListItem, { children: item }, itemId);
    });
    return (_jsx(BasicList, __assign({}, props, { children: listItems }), void 0));
};
export var BasicList = function (props) {
    return (props.type === 'ordered' ? _jsx("ol", __assign({ className: classNames.orderedList }, { children: props.children }), void 0) : _jsx("ul", { children: props.children }, void 0));
};
//# sourceMappingURL=List.js.map